import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from './supabaseClient';

const AppList = () => {
  const [apps, setApps] = useState([]);

  useEffect(() => {
    fetchApps();
  }, []);

  const fetchApps = async () => {
    const { data, error } = await supabase
      .from('app_issues')
      .select('app_name')
      .order('app_name');

    if (error) {
      console.error('Error fetching apps:', error);
    } else {
      const uniqueApps = [...new Set(data.map(item => item.app_name))];
      setApps(uniqueApps);
    }
  };

  const appLogos = {
    'aditya birla': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ0uXxUTmf76IH7IUv3SobYPgnYEnPqlFP3zw&s',
    'paytm': 'https://cdn.icon-icons.com/icons2/730/PNG/512/paytm_icon-icons.com_62778.png',
    'shriram': 'https://play-lh.googleusercontent.com/xAmb2vAFQDzYbmBkTPYdmXEgl5HafdMhWx_auAC9lGlxaTKm2-6joMizdhvXTi1FF7X7',
    'bajaj': 'https://cdn.iconscout.com/icon/free/png-256/free-bajaj-finserv-logo-icon-download-in-svg-png-gif-file-formats--indian-company-companies-pack-logos-icons-2249165.png?f=webp&w=256',
    'navi': 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Navi_New_Logo.png/800px-Navi_New_Logo.png',
    'amazon pay': 'https://cdn-icons-png.flaticon.com/512/5968/5968269.png',
    'phonepe': 'https://i.pinimg.com/originals/db/42/53/db4253052cfc0f80ac281486c19f9d57.png',
    'google pay': 'https://i.pinimg.com/564x/8d/ec/e1/8dece15cc40aaf66ed47f6591b639d06.jpg',
    'kiwi': 'https://ibsintelligence.com/wp-content/uploads/2023/08/kiWI.jpg',
    'bharatpe': 'https://bharatpemoney.com/images/BharatPe-Money--logo.jpg',
    'freecharge': 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/FreeCharge_Logo.png/799px-FreeCharge_Logo.png',
    'genwise': 'https://d2gn4xht817m0g.cloudfront.net/p/media_uploads/images/original/000/716/888/716888-150e2afa70ae2d615668568361f76ea900ee61a8.png?1679027632',
    'niyo': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQxJmXCVUd1atcbJdUl2-tF34ruAUxNCCew5g&s',
    'onecard': 'https://pbs.twimg.com/profile_images/1480798420197462016/FX2rlAeM_400x400.jpg',
    'groww': 'https://logowik.com/content/uploads/images/groww1643.logowik.com.webp',
    'moneytap': 'https://pbs.twimg.com/profile_images/1480763871103049731/z6QHjJpv_400x400.png',
    'pop upi': 'https://play-lh.googleusercontent.com/jqOR__bd_SKMwCV38-A9_9eYi_AOt36bYKmpap9wtZdsaCkSdElYhkwVANGJvOMZGXU',
    'salaryse': 'https://play-lh.googleusercontent.com/aVGFFR3ooPbp_47Us-NTNLfQLQM7KxMphW-KO7EjvUg3AwUiyu41hoMZ9z6WUtTdXcI',
    'samsung pay': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRYYvohcXdmURH03zsZfovye3ZixiWWKUthKQ&s',
    'slice': 'https://res.cloudinary.com/slicepay/image/upload/v1653596191/website/sliceit/assests/press-page/slice-logo-marks.svg',
    'timepay': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSGUYa1VmSKaakhVG8g9lzwbCo-8_QjK1YERg&s',
    'ultracash': 'https://play-lh.googleusercontent.com/msIDCZ9MS-yoG74sjjJX-GsjmaTpArhu7IdOn_Epzx0aN-9pFfPlyk4yfVqL_UKwWOa1',
    'shriram one': 'https://play-lh.googleusercontent.com/xAmb2vAFQDzYbmBkTPYdmXEgl5HafdMhWx_auAC9lGlxaTKm2-6joMizdhvXTi1FF7X7',
  };

  return (
    <div className="HomePage">
      <h1 className="text-2xl font-bold mb-4 relative inline-block">
        <span className="relative z-10">Analyzed Apps</span>
        <span className="absolute bottom-0 left-0 w-full h-1 bg-[#ffe6a1] z-0"></span>
      </h1>
      <div className="AppGrid grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {apps.map((app, index) => (
          <Link key={index} to={`/app/${encodeURIComponent(app)}`} className="block">
            <div className="AppItem bg-card text-card-foreground p-2 rounded-md hover:bg-accent flex flex-col items-center">
              <div className="w-24 h-24 mb-2 overflow-hidden rounded-md relative">
                {appLogos[app.toLowerCase()] ? (
                  <img
                    src={appLogos[app.toLowerCase()]}
                    alt={`${app} logo`}
                    className="absolute w-full h-full object-contain"
                  />
                ) : (
                  <div className="w-full h-full bg-gray-200 flex items-center justify-center text-gray-400">
                    No logo
                  </div>
                )}
              </div>
              <span className="text-center text-sm">{app}</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AppList;
